export default __webpack_public_path__ + "static/media/magicsnacks@3x.b0cafe19.jpg";